module.exports = __webpack_public_path__ + "img/briefcase.06ef153a.svg";